<template>
  <div class="details">
    <div class="card br-2">
      <div class="p-10">
        <div v-if="activityDetails && activityCollapse">
          <h6 class="fw-bold">Activities: {{ activityDetails.length }}</h6>
          <div class>
            <b-link size="sm" @click="expandAll" class="p-0 make-link">
              <span>Expand all</span>
            </b-link>
            <span class="link_style"></span>
            <a href class="col-1 p-0 make-link" @click.prevent="collapseAll()">Collapse all</a>
          </div>
          <div class="pt-8" v-for="(activity, index) in activityDetails" :key="index">
            <div>
              <b-row>
                <b-col cols="3" class="p-0">
                  <i class="fa fa-plus-circle pr-6" v-if="!activityCollapse[activity.id]" @click="expandActivity(activity.id)"></i>
                  <i class="fa fa-minus-circle pr-6" v-if="activityCollapse[activity.id]" @click="collapseActivity(activity.id)"></i>
                  {{ activity.title }}
                </b-col>
                <b-col cols="2" v-if="activity.scheduler">
                  {{ getActivityMode(index) }}
                </b-col>
                <b-col cols="2" v-else-if="activity.schedule">
                  {{ getActivityMode(index) }}
                </b-col>
                <b-col cols="2" v-else-if="activity.segmentSchedules">
                  {{ getActivityMode(index) }}
                </b-col>
                <b-col v-if="activity.isSiteFacing && activity.schedule && activity.schedule.length > 0" cols="4">
                  Milestones:
                  <span> {{ getActivitySchedules(activity.schedule) }} </span>
                </b-col>
                <b-col cols="4" v-else-if="activity.scheduler && activity.scheduler.milestones && activity.scheduler.milestones.length > 0">
                  Milestones:
                  <span v-for="(milestones, index) in activity.scheduler.milestones" :key="index">
                    {{ milestones }}
                    <span v-if="index + 1 < activity.scheduler.milestones.length">,</span>
                  </span>
                </b-col>
                <b-col cols="4" v-if="activity.scheduler && activity.scheduler.frequency">Frequency: {{ activity.scheduler.frequency.title }}</b-col>
                <b-col cols="4" v-if="activity.segmentSchedules && activity.segmentSchedules.length && activity.segmentSchedules[0].frequency">Frequency: {{ activity.segmentSchedules[0].frequency.title }}</b-col>
                <b-col class="pl-10" cols="3" v-if="activity.scheduler && activity.scheduler.activitySchedulingMode && activity.scheduler.activitySchedulingMode != 'dynamicOnly' && activity.scheduler.activitySchedulingMode != 'onDemand'">Dynamic Scheduling: {{ getDynamicSchedulesCount(activity) }} Configured</b-col>
                <b-col class="pl-10" cols="3" v-if="activity.segmentSchedules && activity.segmentSchedules[0].activitySchedulingMode && activity.segmentSchedules[0].activitySchedulingMode != 'dynamicOnly' && activity.segmentSchedules[0].activitySchedulingMode != 'onDemand'">Dynamic Scheduling: {{ getDynamicSchedulesCount(activity) }} Configured</b-col>
              </b-row>
            </div>
            <div v-if="activityCollapse[activity.id]">
              <div class="card inner-card">
                <div class="row color_666669">
                  <div class="col-md-7">
                    <div class="activity-info ml-7 mb-13 vvvvvvvv">
                      Activity Information
                    </div>

                    <!-- Activity info Changes Start -->
                    <div class="activity-info-col">
                      <!-- row1 -->
                      <div class="row d-flex flex-row pb-15">
                        <div class="col">
                          <div class="Activite_Title">Name</div>
                          <span class="">{{ activity.title }}</span>
                        </div>
                        <div class="col">
                          <div class="Activite_Title">Author</div>
                          <span class="">{{ activity.author }}</span>
                        </div>
                      </div>
                      <!-- row2 -->
                      <div class="row d-flex flex-row pb-15">
                        <div class="col">
                          <div class="Activite_Title">Abbreviation</div>
                          <span class="">{{ activity.abbreviation }}</span>
                        </div>
                        <div class="col">
                          <div class="Activite_Title">Copyright</div>
                          <span class="">{{ activity.copyright }}</span>
                        </div>
                      </div>
                      <!-- row3 -->
                      <div class="row d-flex flex-row pb-15">
                        <div class="col">
                          <div class="Activite_Title">Therapeutic area</div>
                          <span v-if="activity.isSiteFacing">
                            {{ getTherapeuticArea(activity.therapeuticArea) }}
                          </span>
                          <span v-else class="">{{ activity.therapeuticArea }}</span>
                        </div>
                        <div class="col">
                          <div class="Activite_Title">Available Languages</div>
                          <span v-if="activity.isSiteFacing" class="">{{ getActivityLanguages(activity.language) }}</span>
                          <span v-else class="">{{ activity.languageCSV }}</span>
                        </div>
                      </div>
                      <!-- row4 -->
                      <div class="row d-flex flex-row pb-15">
                        <div class="col">
                          <div class="Activite_Title">
                            Therapeutic indication
                          </div>
                          <span class="">{{ activity.therapeuticIndication }}</span>
                        </div>
                        <div class="col">
                          <div class="Activite_Title">Groups</div>
                          <span class="">{{ activity.groupName }}</span>
                        </div>
                      </div>
                      <!-- row5 -->
                      <div class="row d-flex flex-row pb-15">
                        <div class="col">
                          <div class="Activite_Title">Permissions</div>
                          <span v-if="activity.isSiteFacing" class="d-block fs-12 mt-8 completed_by">
                            Completed By:
                            {{ arrayStringed(activity.completedBy) }}</span
                          >
                          <span v-else class="d-block fs-12 mt-8 completed_by"> Completed By: {{ activity.completedByCSV }}</span>

                          <span v-if="activity.isSiteFacing" class="fs-12 Activite_Title">
                            Can View:
                            {{ arrayStringed(activity.canViewBy) }}</span
                          >
                          <span v-else class="fs-12 Activite_Title"> Can View: {{ activity.canViewByCSV }}</span>
                        </div>
                        <div class="col">
                          <div class="Activite_Title">
                            Approximate time to complete
                          </div>
                          <span class="">{{ activity.timeToComplete }} min</span>
                        </div>
                      </div>
                      <!-- row6 -->
                      <div class="row d-flex flex-row pb-15" v-if="activity.scheduler && activity.scheduler.isActivityOptional">
                        <div class="col">
                          <div>
                            Activity is optional and will be excluded from the compliance report.
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Changes End -->
                  </div>
                  <div class="col-md-5">
                    <div class="activity-info mb-10">Activity Settings</div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Ability to score responses</label>
                      <span v-if="activity.canScoreResponses == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Allow site users to edit responses</label>
                      <span v-if="activity.allowDataEditChecks == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Available for Apple Watch app</label>
                      <span v-if="activity.watchEnabled == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Custom Participant Message</label>
                      <span v-if="activity.customParticipantMessaging == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Hide Step Numbers</label>
                      <span v-if="activity.hideNumericLabels == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Allow participant to save progress</label>
                      <span v-if="activity.allowSaveProgress == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Enable progress indicators</label>
                      <span v-if="activity.enableProgressIndicator == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Define devices for completion</label>
                      <span v-if="activity.allowDevicesForCompletion == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                    <div class="pb-5">
                      <label class="activity-setting-label">Allow previous responses to be shown</label>
                      <span v-if="activity.allowPreviousResponses == true">Enabled</span>
                      <span v-else>Disabled</span>
                    </div>
                  </div>
                </div>
                <div class="email-section row color_666669" v-if="!activity.isSiteFacing">
                  <div class="col-md-7 pt-15">
                    <div class="Activite_Title pb-8">Email Recipients</div>
                    <div class="Activite_Title pb-10">
                      Questions and answers included:
                    </div>
                    <ul>
                      <li v-for="(question, index) in activity.questions.filter(activityQuestion => activityQuestion.sequence != 100000)" class="text-capitalize" :key="index">
                        {{ question.body }}
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-5 pt-15">
                    <div>
                      <div class="Activite_Title pb-10">Site Teams:</div>
                      <ul>
                        <li v-for="(siteTeamRoleEmail, index) in activity.siteTeamRoleEmails" class="text-capitalize" :key="index">
                          {{ siteTeamRoleEmail }}
                        </li>
                      </ul>
                      <div class="Activite_Title pb-10">Study Teams:</div>
                      <ul>
                        <li v-for="(studyTeamRoleEmail, index) in activity.studyTeamRoleEmails" class="text-capitalize" :key="index">
                          {{ studyTeamRoleEmail }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <router-link
                  class="link-color"
                  :to="{
                    name: 'activity-summary',
                    params: { studyId: studyId, activityId: activity.id }
                  }"
                  target="_blank"
                  >View activity details</router-link
                >
                <!--  Dynamic scheduling details component start-->
                <DynamicSchedulingDetails class="pb-8" :activityDetails="activityDetails[index]" :studyDetails="studyData" :participantRegistrationConfigDetails="participantRegistrationConfigDetails" />
                <!--  Dynamic scheduling details component end-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicSchedulingDetails from "../common/dynamic-scheduling-components-collection/dynamic-scheduling-details";
/* 
IMPORTANT
Any changes made in this file should also be made in the activities-details.vue which is inside the study-details-pdf folder
 */
export default {
  name: "activity-details",
  data() {
    return {
      selectedActivity: {
        id: ""
      },
      studyId: this.$route.params.studyId,
      activityCollapse: {}
    };
  },
  components: {
    DynamicSchedulingDetails
  },
  props: {
    activityDetails: {
      type: Array
    },
    studyData: {
      type: Object
    },
    therapeuticAreas: Array,
    participantRegistrationConfigDetails: {
      type: Array
    }
  },

  methods: {
    filterMilestonesForDisplay() {
      this.activityDetails.forEach(activity => {
        // for activities participant facing
        if (activity.scheduler && activity.scheduler.milestones && activity.scheduler.milestones.length > 0) {
          const newMilestones = activity.scheduler.milestones.map(mileOld => {
            let mile = mileOld;
            return (mile -= this.studyData.screeningDuration);
          });
          activity.scheduler.milestones = newMilestones;
        }
        //for activities site facing
        else if (activity.schedule && activity.schedule.length > 0) {
          activity.schedule.forEach(mile => (mile.milestoneDay -= this.studyData.screeningDuration));
        }
      });
    },
    expandActivity(id) {
      this.selectedActivity.id = id;
      this.activityCollapse[id] = true;
      this.$forceUpdate();
    },
    getActivitySchedules(arr) {
      const miles = arr.map(mile => mile.milestoneDay).sort();
      return miles.join(" , ");
    },
    getActivityLanguages(arr) {
      const names = arr.map(lang => lang.name);
      return names.join(",");
    },
    arrayStringed(arr) {
      return arr.join(",");
    },
    getTherapeuticArea(id) {
      const therapeuticArea = this.therapeuticAreas.filter(item => item.id == id);
      if (therapeuticArea[0] && therapeuticArea[0].name) {
        return therapeuticArea[0].name;
      }
    },
    collapseActivity(id) {
      this.selectedActivity.id = "";
      this.activityCollapse[id] = false;
      this.$forceUpdate();
    },
    expandAll() {
      this.activityDetails.forEach(activity => {
        this.activityCollapse[activity.id] = true;
      });
      this.$forceUpdate();
    },
    collapseAll() {
      this.selectedActivity.id = "";
      this.activityDetails.forEach(activity => {
        this.activityCollapse[activity.id] = false;
      });
      this.$forceUpdate();
    },
    getActivityMode(index) {
      const activity = this.activityDetails[index];
      if (activity.scheduler && activity.scheduler.activitySchedulingMode) {
        if (activity.scheduler.activitySchedulingMode === "schedule") {
          return "Scheduled";
        } else if (activity.scheduler.activitySchedulingMode === "both") {
          return "Scheduled and On-demand";
        } else if (activity.scheduler.activitySchedulingMode === "onDemand") {
          return "On-demand";
        } else {
          return "Dynamic Only";
        }
      } else if (activity.segmentSchedules && activity.segmentSchedules.length && activity.segmentSchedules[0].activitySchedulingMode) {
        if (activity.segmentSchedules[0].activitySchedulingMode === "schedule") {
          return "Scheduled";
        } else if (activity.segmentSchedules[0].activitySchedulingMode === "both") {
          return "Scheduled and On-demand";
        } else if (activity.segmentSchedules[0].activitySchedulingMode === "onDemand") {
          return "On-demand";
        } else {
          return "Dynamic Only";
        }
      } else {
        return "Scheduled";
      }
    },
    getDynamicSchedulesCount(activity) {
      if (activity && activity.scheduler && activity.scheduler.dynamicScheduling && activity.scheduler.dynamicScheduling.length) {
        // Dynamic-schedules in Participant activities.
        return activity.scheduler.dynamicScheduling.length;
      } else if (activity && activity.segmentSchedules && activity.segmentSchedules[0] && activity.segmentSchedules[0].dynamicScheduling && activity.segmentSchedules[0].dynamicScheduling.length > 0) {
        // Dynamic-schedules in Participant activities in case of segmentSchedules object.
        return activity.segmentSchedules[0].dynamicScheduling.length;
      } else if (activity && activity.dynamicSchedule && activity.dynamicSchedule.length) {
        // Dynamic-schedules in Site activities.
        return activity.dynamicSchedule.length;
      } else {
        return "0";
      }
    }
  },
  watch: {
    activityDetails() {
      if (this.activityDetails && this.activityDetails.length) {
        this.activityDetails.forEach(activity => {
          this.activityCollapse[activity.id] = false;
        });

        if (this.studyData.screeningMilestoneAllowed) {
          this.filterMilestonesForDisplay();
        }
      }
    }
  }
};
</script>

<style scoped>
.email-section {
  border-top: 1px solid #959fa4;
}
.link_style {
  border-right: 1px solid #959fa4;
  margin: 0px 5px 0px 2px !important;
}
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.activity-info {
  margin-top: 15px;
  font-size: 14px;
  color: #000000;
}
.activity-setting-label {
  width: 80%;
}
.activity-row {
  margin-top: 18px;
  margin-left: 22px;
  margin-bottom: 23px;
  font-size: 14px;
  color: #666669;
}

.content {
  font-size: 12px;
  color: #666669;
}
.header {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}
.link-color {
  font-size: 12px;
  color: #4c8ce4;
  padding: 0px 15px 15px 15px;
}
.make-link {
  color: #007bff !important;
}
.Activite_Title {
  line-height: 14px;
}
/* .completed_by{
  line-height: 4px;

} */
.activity-info-col .col {
  padding-left: 7px;
}
</style>
